import Parse from 'parse/dist/parse.min.js';
import { handleParseError } from '../../lib/Errors';

let localSubscription = undefined;

function createSubscription(store) {
	let dataQuery = new Parse.Query('MedicationForm');
	dataQuery.notEqualTo("deleted", true)
	dataQuery.addAscending("name")
	dataQuery.find()
		.then((results) => {
			store.dispatch('medicationForm/set', results)
		})
		.catch((error) => {
			handleParseError(error);
			
		});
		dataQuery.subscribe().then((subscription) => {
		
		localSubscription = subscription;

		subscription.on('create', object => {
			
			store.dispatch('medicationForm/insert', object)
		});
		subscription.on('update', object => {
			
			store.dispatch('medicationForm/replace', object)
		});
		subscription.on('enter', object => {
			
			store.dispatch('medicationForm/insert', object)
		});
		subscription.on('leave', object => {
			
			store.dispatch('medicationForm/delete', object)
		});
		subscription.on('delete', object => {
			
			store.dispatch('medicationForm/delete', object)
		});
		subscription.on('close', () => {
		});
		subscription.on('error', error => {
            console.log('MedicationFrom subscription error', error);
        })
	})
}

export default function createMedicationFormSubscription() {
	return store => {
		if (store.state.currentUser) {
			createSubscription(store)
		}
		store.subscribe(mutation => {
			if (mutation.type === 'SET_CURRENT_USER') {
				if (localSubscription) {
					localSubscription.unsubscribe()
				}
				if (store.state.currentUser) {
					createSubscription(store)
				}
			}
		})
	}
}
